import '../styles/components/Navbar.css';
import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { m } from 'framer-motion';

function TopbarPhoneIcon() {
  return (
    <svg className="topbar-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path
        fill="currentColor"
        d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
      />
    </svg>
  );
}

function TopbarMailIcon() {
  return (
    <svg className="topbar-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path
        fill="currentColor"
        d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"
      />
    </svg>
  );
}

const navList = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.06, delayChildren: 0.28 },
  },
};

const navItem = {
  hidden: { opacity: 0, y: 10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.36, ease: [0.22, 1, 0.36, 1] },
  },
};

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 700) setIsMenuOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <m.header
      className="site-header"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
    >
      <m.div
        className="topbar"
        initial={{ opacity: 0, y: -14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.42, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="topbar-inner">
          <div className="topbar-right">
            <a className="topbar-item" href="tel:+255625313162">
              <TopbarPhoneIcon />
              <span>+255 625 313 162</span>
            </a>
            <a className="topbar-item" href="mailto:info@ablconstruction.co.tz">
              <TopbarMailIcon />
              <span>info@ablconstruction.co.tz</span>
            </a>
          </div>
        </div>
      </m.div>

      <m.nav
        className="navbar"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, delay: 0.04, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="navbar-inner">
          <m.div
            className="navbar-brand-wrap"
            initial={{ scale: 0.88, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 280, damping: 22, delay: 0.12 }}
          >
            <Link className="navbar-brand" to="/" aria-label="Go to home" onClick={closeMenu}>
              <img src="/img/samplelogo.jpeg" className="navbar-logo" alt="Company logo" />
            </Link>
          </m.div>

          <m.button
            type="button"
            className="navbar-toggle"
            aria-controls="primary-navigation"
            aria-expanded={isMenuOpen}
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            onClick={() => setIsMenuOpen((v) => !v)}
            whileTap={{ scale: 0.94 }}
          >
            <span className="navbar-toggle-bar" />
            <span className="navbar-toggle-bar" />
            <span className="navbar-toggle-bar" />
          </m.button>

          <m.ul
            id="primary-navigation"
            className={`navbar-links ${isMenuOpen ? 'is-open' : ''}`}
            variants={navList}
            initial="hidden"
            animate="visible"
          >
            <m.li variants={navItem}>
              <NavLink className={({ isActive }) => (isActive ? 'active' : undefined)} to="/" end onClick={closeMenu}>
                Home
              </NavLink>
            </m.li>
            <m.li variants={navItem}>
              <Link to="/#about" onClick={closeMenu}>
                About Us
              </Link>
            </m.li>
            <m.li variants={navItem}>
              <Link to="/#services" onClick={closeMenu}>
                Services
              </Link>
            </m.li>
            <m.li variants={navItem}>
              <NavLink
                className={({ isActive }) => (isActive ? 'active' : undefined)}
                to="/aggregates"
                onClick={closeMenu}
              >
                Pebbles Category
              </NavLink>
            </m.li>
            <m.li variants={navItem}>
              <NavLink
                className={({ isActive }) => (isActive ? 'active' : undefined)}
                to="/land-plot"
                onClick={closeMenu}
              >
                Land Plot
              </NavLink>
            </m.li>
            <m.li variants={navItem}>
              <NavLink
                className={({ isActive }) => (isActive ? 'active' : undefined)}
                to="/contact"
                onClick={closeMenu}
              >
                Contact Us
              </NavLink>
            </m.li>
          </m.ul>
        </div>
      </m.nav>
    </m.header>
  );
}

export default Navbar;
